(function () {
  'use strict'

  function getAmountsTableDOMElement() {
    return $('tbody.amounts_table_body')[0]
  }

  function setUpAmountsTableMutationObserver() {
    const amountsTable = getAmountsTableDOMElement()

    const options = {
      childList: true
    }

    const addOrRemoveAmountObserver = new MutationObserver(mCallback)

    function mCallback(mutations) {
      const numberOfMutations = mutations.length

      for (let i = 0; i < numberOfMutations; i++) {
        const mutation = mutations[i]

        if (mutation.type === 'childList') {
          addAmountFormEventListenersAndDisableTaxCodeSelectsForTaxControlAccounts()
        }
      }
    }

    addOrRemoveAmountObserver.observe(amountsTable, options)
  }

  function addAmountFormEventListeners() {
    $('select.nominal_account_selector').on('change', nominalAccountChange)
  }

  function addAmountFormEventListenersAndDisableTaxCodeSelectsForTaxControlAccounts() {
    addAmountFormEventListeners()
    $('select.nominal_account_selector')
      .on(
        'disable_and_blank_tax_control_tax_codes',
        disableAndBlankTaxCodeSelectsWithNoAccountOrATaxControlAccount
      ).trigger('disable_and_blank_tax_control_tax_codes')
  }

  function disableAndBlankTaxCodeSelectsWithNoAccountOrATaxControlAccount(event) {
    event.preventDefault()
    updateTaxCodeWhenNominalAccountChanges(event, true)
  }

  function nominalAccountChange(event) {
    event.preventDefault()
    const taxCodeCanChange = event.currentTarget.dataset.lockedToVatReturn !== "true"
    if(taxCodeCanChange) {
      updateTaxCodeWhenNominalAccountChanges(event, false)
    }
  }

  function updateTaxCodeWhenNominalAccountChanges(event, onlyAffectTaxControlAccounts) {
    const amountRow = getClosestAmountRowToEvent(event)
    const selectedNominalAccount = getSelectedNominalAccount(amountRow)
    const taxCodeSelect = getTaxCodeSelect(amountRow)

    const isATaxControlAccount = selectedNominalAccount.data('isATaxControlAccount')
    const defaultTaxCode = selectedNominalAccount.data('defaultTaxCodeId')

    if (onlyAffectTaxControlAccounts && (isATaxControlAccount === false)) {
      return
    }

    const select = new TaxCodeSelect(taxCodeSelect);

    isATaxControlAccount ? select.disable() : select.enable()

    return (!defaultTaxCode && !isATaxControlAccount) ? null : select.setValue(defaultTaxCode)
  }

  function getClosestAmountRowToEvent(event) {
    return $(event.currentTarget).closest('tr.amount_row')
  }

  function getSelectedNominalAccount(row) {
    return $(row).find('select.nominal_account_selector').find(':selected')
  }

  function getTaxCodeSelect(row) {
    return $(row).find('select.tax_code_field')
  }

  function TaxCodeSelect(taxCodeSelectElementRef) {
    this.taxCodeSelect = taxCodeSelectElementRef
  }

  TaxCodeSelect.prototype.setValue = function (value) {
    this._setTaxCode(value)
  }

  TaxCodeSelect.prototype.enable = function () {
    this._setDisabledAttribute(false)
  }

  TaxCodeSelect.prototype.disable = function () {
    this._setDisabledAttribute(true)
  }

  TaxCodeSelect.prototype._setTaxCode = function (value) {
    this.taxCodeSelect.val(value).trigger('change').trigger('chosen:updated')
  }

  TaxCodeSelect.prototype._setDisabledAttribute = function (booleanValue) {
    this.taxCodeSelect.attr('disabled', booleanValue).trigger('chosen:updated')
  }

  document.addEventListener('turbo:load', function () {
    if ($('[data-vat-adjustment-form]').length === 0) { return }

    addAmountFormEventListenersAndDisableTaxCodeSelectsForTaxControlAccounts()
    setUpAmountsTableMutationObserver()
  })
})()
